module.exports = __webpack_public_path__ + "static/shyamala-big.33315903.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/shyamala-big.jpg
// module id = 933
// module chunks = 186873666987998